import { LocalStyles } from "@paperbits/common/styles";

export class ProductDetailsModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
